import { createSlice } from '@reduxjs/toolkit';
import { formatPeriodSelectionToISO } from 'Utils/dates/helpers';
export const initialState = {
    currentEvent: null,
    currentEventPeriodSelection: null,
    currentEventCulpritTagsSelection: null,
    currentModelEventSelection: null,
    isEnabledCurrentModelEventCreation: false,
    isLoading: false,
    eventSelectionRequestVersion: 0,
    error: null,
    homeReturnTab: null
};
const monitoringEventSlice = createSlice({
    name: 'monitoringEvent',
    initialState,
    reducers: {
        setCurrentMonitoringEventBody: (state, action) => {
            state.currentEvent = action.payload;
        },
        setCurrentMonitoringEventPeriodSelection: (state, action) => {
            const period = formatPeriodSelectionToISO(action.payload);
            state.currentEventPeriodSelection = period;
        },
        setCurrentModelEventSelectionAndType: (state, action) => {
            state.currentModelEventSelection = action.payload;
        },
        setCurrentEventCulpritTagsSelection: (state, action) => {
            state.currentEventCulpritTagsSelection = action.payload;
        },
        setIsEnabledCurrentModelEventCreation: (state, action) => {
            state.isEnabledCurrentModelEventCreation = action.payload;
        },
        setIsLoadingCurrentMonitoringEvent: (state, action) => {
            state.isLoading = action.payload;
            if (action.payload)
                state.eventSelectionRequestVersion += 1;
        },
        setErrorLoadingCurrentMonitoringEvent: (state, action) => {
            state.error = action.payload;
        },
        setHomeReturnTab: (state, action) => {
            state.homeReturnTab = action.payload;
        },
        updateHomeReturnTabSubPage: (state, action) => {
            if (state.homeReturnTab && state.homeReturnTab.eventId === action.payload.eventId) {
                state.homeReturnTab.subPage = action.payload.subPage;
            }
        },
        clearHomeReturnTab: (state) => {
            state.homeReturnTab = null;
        },
        // Do not reuse a request version after clearing and starting another selection.
        clearEventState: (state) => ({
            ...initialState,
            eventSelectionRequestVersion: state.eventSelectionRequestVersion + 1
        })
    }
});
export const { setCurrentMonitoringEventBody, setCurrentMonitoringEventPeriodSelection, setCurrentModelEventSelectionAndType, setIsEnabledCurrentModelEventCreation, setIsLoadingCurrentMonitoringEvent, setErrorLoadingCurrentMonitoringEvent, setCurrentEventCulpritTagsSelection, setHomeReturnTab, updateHomeReturnTabSubPage, clearHomeReturnTab, clearEventState } = monitoringEventSlice.actions;
export default monitoringEventSlice.reducer;
